import Control from "ol/control/Control";

export class DataSourceControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const div = document.createElement("div");
    super({
      element: div,
      target: options.target,
    });
    const this_ = this;

    div.className = "data-source";

    const label = document.createElement("p");
    label.innerText = "Data source selection";
    label.className = "data-source-label";

    div.appendChild(label);

    const radios = [];
    for (let i = 0; i < 6; i++) {
      const radio = document.createElement("input");
      radio.type = "radio";
      radio.name = "data-source";
      radio.value = i;
      radio.id = "radio-" + i;
      radios.push(radio);

      if (i == 4) {
        radio.checked = true;
        this_.set("dataSource", i);
      }

      radio.addEventListener("change", function () {
        this_.set("dataSource", i);
      });

      const radioLabel = document.createElement("label");
      radioLabel.htmlFor = "radio-" + i;
      radioLabel.innerText = i;

      div.appendChild(radio);
      div.appendChild(radioLabel);
    }

    this.on("propertychange", function (e) {
      if (e.key === "dataSource") {
        const val = this_.get("dataSource");
        radios.forEach(function (r, i) {
          r.checked = i === val;
        });
      }
    });
  }
}
